import { NomadDB } from '~/db/NomadDB.js';

export const getVersionsService = (db: NomadDB) => {
  const get = async (): Promise<string> => {
    const data = await db.versions.get({ id: '1' });
    return data ? data.version : null;
  };

  const save = async (version: string): Promise<any> => {
    return await db.versions.put({ id: '1', version });
  };

  return {
    get,
    save,
  };
};
